/****************************************
	Autocomplete
*****************************************/
;(function ($) {
	'use strict';
	var shared = {
			'debounce': function (callback, delay, immediate) {
				return this.throttle(callback, delay, undefined, !!immediate);
			},
			'escapeRegExp': function (str) {
				return str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
			},
			'focusable': function (element, isTabIndexNotNaN) {
				var nodeName = element.nodeName.toLowerCase();
				return (/input|select|textarea|button|object/.test(nodeName) ? !element.disabled : ('a' === nodeName) ? (element.href || isTabIndexNotNaN) : isTabIndexNotNaN) && this.visible(element);
			},
			'isValidCallback': function (callback) {
				return callback && $.isFunction(callback);
			},
			'lang': (function () {
				var langAttr = $('html').attr('lang') || $('[lang]').first().attr('lang');
				return langAttr ? langAttr.toLowerCase() : 'en';
			}()),
			'localize': function (langSet, key) {
				if (langSet[this.lang] && langSet[this.lang][key]) {
					return langSet[this.lang][key];
				}
				if (langSet[this.lang.substring(0, 2)] && langSet[this.lang.substring(0, 2)][key]) {
					return langSet[this.lang.substring(0, 2)][key];
				}
				return langSet.en[key] || '';
			},
			'getTabbableElements': function ($container) {
				var self = this;
				return $container
					.find('input, select, textarea, button, a, object, [tabindex]')
					.filter(function () {
						return self.tabbable(this);
					});
			},
			'tabbable': function (element) {
				var tabIndex = $.attr(element, 'tabindex'),
					isTabIndexNaN = isNaN(tabIndex);
				return (isTabIndexNaN || tabIndex >= 0) && this.focusable(element, !isTabIndexNaN);
			},
			'throttle': function (callback, delay, noTrail, immediate) {
				var timeout,
					previous = 0,
					result = function () {
						var self = this,
							elapsed = Date.now() - previous,
							args = arguments,
							timeoutCallback,
							timeoutDelay;
						function reset() {
							timeout = undefined;
						}
						function execute() {
							previous = Date.now();
							callback.apply(self, args);
						}
						if (immediate && !timeout) {
							execute();
						}
						if (timeout) {
							clearTimeout(timeout);
						}
						if (immediate === undefined && elapsed > delay) {
							execute();
						} else if (noTrail !== true) {
							timeoutCallback = immediate ? reset : execute;
							timeoutDelay = immediate === undefined ? delay - elapsed : delay;
							timeout = setTimeout(timeoutCallback, timeoutDelay);
						}
					};
				return result;
			},
			'visible': function (element) {
				return $.expr.filters.visible(element) && !$(element).parents().andSelf().filter(function () {
					return $.css(this, 'visibility') === 'hidden';
				}).length;
			},
			'warn': function (msg, useAlert) {
				if (window.console) {
					console.warn(msg);
					if (useAlert && /ancestry(?:stage|dev)/.test(window.location.hostname)) {
						alert(msg);
					}
				}
			}
		},
		autocomplete = {
			'create': function ($element, options) {
				var CrossBrowserMutationObserver = window.MutationObserver || window.WebKitMutationObserver,
					instance = $element.data('autocompleteInstance'),
					id = $element.attr('id'),
					config;
				if (instance) {
					instance.destroy();
				}
				if (!options.key) {
					return;
				}
				/* create and add #autocomplete element to the body if it does not exist */
				if (!$('#autocomplete').length) {
					$('body').append('<div id="autocomplete"></div>');
				}
				instance = Object.create(this.proto);
				instance.config = $.extend({}, this.staticProperties.defaults, options);
				config = instance.config;
				config.minLength = Math.max(1, config.minLength);
				instance.$element = $element;
				/* instance state data */
				instance.cachedData = {};
				instance.isOpen = false;
				instance.results = [];
				instance.screenTouches = {};
				instance.term = '';
				/* instance elements */
				instance.$autocomplete = $('#autocomplete');
				instance.$container = $('<div id = "' + id + 'ResultCon" class="autocompleteCon" />');
				instance.$resultsList = $('<ul id="' + id + 'Results" class="autocompleteResults loading" role="listbox" />');
				$element
					.addClass('autocompleteInput')
					.attr({
						'aria-autocomplete': 'list',
						'aria-controls': id + 'Results',
						'aria-expanded': 'false',
						'aria-owns': id + 'Results',
						'autocomplete': 'off',
						'role': 'combobox'
					});
				instance.$container.append(instance.$resultsList);
				instance.$autocomplete.append(instance.$container);
				instance.observer = new CrossBrowserMutationObserver(function () {
					instance._handleDomChangesWhileOpen();
				});
				instance.observerOptions = {
					attributes: true,
					childList: true,
					characterData: true,
					subtree: true
				};
				/* add events */
				instance.$container
					.on('click.autocomplete', function () {
						return instance._handleResultsClick();
					})
					.on('keydown.autocomplete', function (e) {
						return instance._handleResultsKeydown(e);
					})
					.on('keyup.autocomplete', function (e) {
						return instance._handleResultsKeyup(e);
					});
				$element
					.on('input.autocomplete', function () {
						if ($element.data('raw')) {
							$element.removeData('raw');
							if (shared.isValidCallback(config.onChange)) {
								config.onChange.apply($element, []);
							}
						}
						return;
					})
					.on('keydown.autocomplete', function (e) {
						return instance._handleInputKeydown(e);
					})
					.on('keyup.autocomplete', function (e) {
						return instance._handleInputKeyup(e);
					})
					.on('focusin.autocomplete', function () {
						return instance._handleInputFocusin();
					});
				/* Save instance to $element */
				$element.data('autocompleteInstance', instance);
				if (shared.isValidCallback(config.onCreate)) {
					config.onCreate.apply($element, []);
				}
				return instance;
			},
			'proto': {
				'_ajaxRequest': function () {
					var self = this,
						config = this.config,
						overrides,
						params = {},
						originalAjaxObject,
						updatedAjaxObject,
						haveFullDataset = false;
					if (config.queryParameter) {
						params[config.queryParameter] = this.term;
					}
					originalAjaxObject = {
						url: config.source,
						data: params,
						dataType: config.dataType,
						error: function (jqXHR, textStatus, errorThrown) {
							shared.warn('Autocomplete Source ' + config.source + ' cannot be reached');
							if (shared.isValidCallback(config.onError)) {
								config.onError.apply(self.$element, [jqXHR, textStatus, errorThrown]);
							}
							self.close();
						},
						success: function (data) {
							var dirtyResults = [],
								cleanResults,
								parent;
							if (shared.isValidCallback(config.jsonConversion)) {
								dirtyResults = config.jsonConversion.apply(self.$element, [data, config]);
							} else if (config.dataType === 'xml') {
								parent = $(data).find(config.key).parent();
								parent.each(function () {
									var returnObj = {};
									$(this)
										.children()
										.each(function () {
											returnObj[this.nodeName] = $(this).text();
										});
									dirtyResults.push(returnObj);
								});
							} else {
								dirtyResults = data;
							}
							if (haveFullDataset) {
								self.results = dirtyResults;
							}
							cleanResults = self._cacheResults(dirtyResults);
							if (!cleanResults.length && config.disableNoResultsMessage) {
								self.close();
							} else {
								self._open();
								self._populate(cleanResults);
							}
						}
					};
					this.$resultsList.addClass('loading');
					if (shared.isValidCallback(config.ajaxOverride)) {
						overrides = config.ajaxOverride.apply(this.$element, [{
							'url': originalAjaxObject.url,
							'data': originalAjaxObject.data,
							'dataType': originalAjaxObject.dataType
						}]);
					} else {
						overrides = config.ajaxOverride;
					}
					updatedAjaxObject = $.extend({}, originalAjaxObject, overrides);
					if ($.isEmptyObject(updatedAjaxObject.data)) {
						haveFullDataset = true;
					}
					$.ajax(updatedAjaxObject);
				},
				'_bindMouseEvents': function () {
					var self = this;
					this.$container
						.on('mouseenter.autocomplete', '.autocompleteResult:not([aria-disabled]):not(.autocompleteNoResults)', function (e) {
							self.$focus = self._focusItem($(e.currentTarget));
							return true;
						})
						.on('mouseleave.autocomplete', '.autocompleteResult:not([aria-disabled]):not(.autocompleteNoResults)', function (e) {
							/* IE11 has an odd touch behavior that triggers an extra mouseleave event before selecting an item. In that extra event the 'relatedTarget' property is null. Once we drop support for IE11 touch, we can remove the condition from this clearFocus call. */
							if (e.relatedTarget) {
								self._clearFocus();
							}
							return true;
						});
				},
				'_buildResult': function (item, i, elementId) {
					var self = this,
						config = this.config,
						$result = '',
						attributes = 'tabindex="0"',
						classes = 'autocompleteResult',
						id = elementId + 'Autocomplete' + i,
						itemData = {
							'term': this.term,
							'value': item[config.key],
							'display': this._getHighlightedValue(this.term, item[config.key]),
							'raw': item
						};
					if (shared.isValidCallback(config.customDisplay)) {
						itemData = config.customDisplay.apply(this.$element, [itemData]);
					}
					if (itemData.checked === true) {
						classes += ' autocompleteChecked iconAfter iconAfterCheck';
					}
					if (itemData.disabled) {
						attributes = 'aria-disabled="true"';
					}
					$result = $('<li ' + attributes + ' class="' + classes + '" role="option" aria-selected="false" id="' + id + '"><div class="textWrap">' + itemData.display + '</div></li>');
					$result.data({
						'raw': item,
						'value': itemData.value
					});
					if (!itemData.disabled) {
						$result.on('click.autocomplete', function (e) {
							return self._handleResultClick(e);
						});
					}
					return $result;
				},
				'_cacheResults': function (dirtyResults) {
					var self = this,
						cleanResults = [];
					if (this.config.queryParameter) {
						cleanResults = dirtyResults;
					} else {
						dirtyResults.forEach(function (item) {
							if (self._compare(item)) {
								cleanResults.push(item);
							}
						});
					}
					this.cachedData[this.term.toLowerCase()] = cleanResults;
					return cleanResults;
				},
				'_clearFocus': function () {
					if (this.$focus) {
						this.$focus
							.removeAttr('aria-selected')
							.removeClass('autocompleteSelected');
						this.$focus = false;
					}
				},
				'close': function () {
					var config = this.config,
						id = this.$element.attr('id');
					if (this.isOpen) {
						if (shared.isValidCallback(config.onClose)) {
							config.onClose.apply(this.$element, [this.$container, this.$before, this.$after]);
						}
						if (this.$before) {
							this.$before.remove();
							this.$before = false;
						}
						if (this.$after) {
							this.$after.remove();
							this.$after = false;
						}
						/* move $autocomplete back to body if it is in a modal */
						if (this.inModal || this.inCallout) {
							this.$autocomplete.appendTo('body');
						}
						$(window).add('html').add('body').off('.autocomplete.' + id);
						this._clearFocus();
						this.$container
							.off('mouseenter.autocomplete mouseleave.autocomplete')
							.removeClass('autocompleteVisible autocompleteInModal autocompleteInCallout');
						this.$resultsList.empty();
						this.$autocomplete.css('max-height', '');
						this.$element
							.attr('aria-expanded', 'false')
							.removeClass('autocompleteAttached autocompleteInputInCallout');
						this.isOpen = false;
						this.observer.disconnect();
						this.$element.trigger('closed.autocomplete');
					}
				},
				'_compare': function (item) {
					var config = this.config,
						regEx = new RegExp(shared.escapeRegExp(this.term), 'gi'),
						termSearch = item[config.key].search(regEx);
					return (config.matchBeginning && termSearch === 0) || (!config.matchBeginning && termSearch !== -1);
				},
				'destroy': function () {
					this.close();
					this.$element.add(this.$container).add(this.$resultsList).off('.autocomplete');
					this.$element
						.removeClass('autocompleteInput')
						.removeAttr('aria-autocomplete aria-controls aria-expanded aria-owns autocomplete role')
						.removeData('autocompleteInstance raw');
					this.$container.remove();
				},
				'flush': function () {
					this.cachedData = {};
				},
				'_focusItem': function ($item) {
					this._clearFocus();
					$item
						.addClass('autocompleteSelected')
						.focus();
					if ($item.closest(this.$resultsList).length) {
						$item.attr('aria-selected', 'true');
					}
					if (shared.isValidCallback(this.config.onFocus)) {
						this.config.onFocus.apply(this.$element, [$item]);
					}
					return $item;
				},
				'_getHighlightedValue': function (searchTerm, highlightedValue) {
					var config = this.config,
						openPattern,
						closePattern,
						regex;
					if (config.highlight) {
						regex = new RegExp(shared.escapeRegExp(searchTerm), 'gi');
						if (config.highlight === true) {
							highlightedValue = highlightedValue.replace(regex, function (matched) {
								return '<span class="autocompleteHighlighted">' + matched + '</span>';
							});
						} else {
							openPattern = new RegExp(shared.escapeRegExp(config.highlight.open), 'g');
							closePattern = new RegExp(shared.escapeRegExp(config.highlight.close), 'g');
							highlightedValue = highlightedValue
								.replace(openPattern, '<span class="autocompleteHighlighted">')
								.replace(closePattern, '</span>');
						}
					}
					return highlightedValue;
				},
				'_handleFocusOrMouseDownOnOtherElement': function (e) {
					var $target = $(e.target),
						targetInContainer = !!$target.closest(this.$container).length,
						targetIsCurrentCallout = this.inCallout && $target.is('#calloutContent'),
						targetIsCurrentElement = $target.is(this.$element);
					/*	This check is to see if a new element is focused outside of the current autocomplete (such as another input).
						The variable targetIsCurrentCallout is needed because Safari and FF incorrectly place focus onto the
						#calloutContent element because it has tabindex="-1". Since #calloutContent is not within the autocomplete
						container, it would cause the autocomplete to close before event would occur on the children elements. */
					if (!targetInContainer && !targetIsCurrentCallout && !targetIsCurrentElement) {
						this.close();
					}
					return true;
				},
				'_handleDomChangesWhileOpen': function () {
					var self = this;
					this.observer.disconnect();
					this._positionAutocomplete();
					/*	Need to wait until after 300ms delay in _positionAutocomplete() to re-observe
						DOM changes due to Firefox updating attributes even when they are unchanged */
					setTimeout(function () {
						if (self.isOpen) {
							self.observer.observe(document.body, self.observerOptions);
						}
					}, 310);
				},
				'_handleHtmlTouchendOrClick': function (e) {
					var $target = $(e.target),
						isLabel = $target.attr('for'),
						$input = isLabel ? $('#' + isLabel) : false,
						isTapEvent = e.originalEvent.changedTouches ? Math.max(Math.abs(this.screenTouches.x - e.originalEvent.changedTouches[0].pageX), Math.abs(this.screenTouches.y - e.originalEvent.changedTouches[0].pageY)) < 5 : false,
						targetInAutocomplete = !!$target.closest(this.$autocomplete).length,
						targetInElement = !!$target.closest(this.$element).length;
					/* prevent close when clicking inside autocomplete not on a result */
					if (!targetInElement && !targetInAutocomplete && (($input && !$input.hasClass('autocompleteAttached')) || (!$input && !$target.hasClass('autocompleteAttached')))) {
						if (e.type === 'click' || isTapEvent) {
							this.close();
						}
					}
					return true;
				},
				'_handleHtmlTouchstart': function (e) {
					this.screenTouches.x = e.originalEvent.touches ? e.originalEvent.touches[0].pageX : e.pageX;
					this.screenTouches.y = e.originalEvent.touches ? e.originalEvent.touches[0].pageY : e.pageY;
					return true;
				},
				'_handleInputFocusin': function () {
					if (this.isOpen) {
						this._clearFocus();
					} else {
						this._retrieveResults();
					}
					return true;
				},
				'_handleInputKeydown': function (e) {
					var key = e.which;
					if (key === 9 || key === 27) { /* Tab || Esc */
						this.close();
					} else if (key === 38 || key === 40) { /* Up || Down */
						return false;
					}
					return true;
				},
				'_handleInputKeyup': function (e) {
					var key = e.which;
					if (key === 38 || key === 40) { /* Up || Down */
						this._navigateListItems(key === 38);
						return false;
					}
					if (key !== 9 && key !== 13 && key !== 16 && key !== 27) { /* Tab || Enter || Shift || Esc */
						this.run();
					}
					return true;
				},
				'_handleResultClick': function (e) {
					var $result = $(e.currentTarget);
					if ($result.attr('aria-disabled')) {
						return false;
					}
					this._selectItem($result);
					return true;
				},
				'_handleResultsClick': function () {
					if (this.inModal && $.modal) {
						$.modal.preventClosing();
					}
					return true;
				},
				'_handleResultsKeydown': function (e) {
					var key = e.which,
						$result = $(e.target),
						isResult = !!$result.closest(this.$resultsList).length,
						tabOnResult = isResult && key === 9, /* Tab */
						enterOnResult = isResult && key === 13, /* Enter */
						shouldSelectResult = tabOnResult || enterOnResult,
						shouldStopEvent = enterOnResult || key === 27 || key === 38 || key === 40, /* Esc || Up || Down */
						shouldClose = key === 27 || (key === 9 && !isResult), /* Esc || Tab on a non-result item */
						shouldFocusOnElement = shouldClose || (!shouldStopEvent && key !== 13 && !$result.is('input, textarea'));
					if (shouldSelectResult) {
						this._selectItem($result);
					} else if (shouldFocusOnElement) {
						this.$element.focus();
					}
					if (shouldClose) {
						this.close();
					}
					return !shouldStopEvent;
				},
				'_handleResultsKeyup': function (e) {
					var key = e.which;
					if (key === 40 || key === 221) { /* Down || ] */
						this._navigateListItems();
					}
					if (key === 38 || key === 219) { /* Up || [ */
						this._navigateListItems(true);
					}
					return true;
				},
				'_navigateListItems': function (reverse) {
					var currentIndex,
						targetIndex,
						$targetElement = false,
						$endElement,
						$tabbable;
					$tabbable = shared.getTabbableElements(this.$container);
					if (!$tabbable.length) {
						/* There are no results and no interactive content */
						return false;
					}
					if (!this.$focus) {
						$targetElement = reverse ? $tabbable.last() : $tabbable.first();
					} else {
						$endElement = reverse ? $tabbable.first() : $tabbable.last();
						if (!this.$focus.is($endElement)) {
							currentIndex = $tabbable.index(this.$focus);
							targetIndex = reverse ? currentIndex - 1 : currentIndex + 1;
							$targetElement = $tabbable.eq(targetIndex);
						}
					}
					if ($targetElement) {
						this.$focus = this._focusItem($targetElement);
					} else {
						this.$element.focus();
					}
				},
				'_open': function () {
					var self = this,
						config = this.config,
						id = this.$element.attr('id');
					this.inModal = this.$element.closest('.modal, #modal').length > 0;
					this.inCallout = this.$element.closest('#callout').length > 0;
					this.$resultsList
						.off('click.autocomplete.noResults')
						.removeClass('loading autocompleteHasChecks')
						.empty();
					if (!this.inCallout) {
						this._positionAutocomplete();
					}
					if (!this.isOpen) {
						if (shared.isValidCallback(config.onOpen)) {
							this.$before = $('<div class="autocompleteBefore" />');
							this.$after = $('<div class="autocompleteAfter" />');
							config.onOpen.apply(this.$element, [this.$container, this.$before, this.$after]);
							if (!this.$before.is(':empty')) {
								this.$resultsList.before(this.$before);
							}
							if (!this.$after.is(':empty')) {
								this.$resultsList.after(this.$after);
							}
						}
						this.$element
							.addClass('autocompleteAttached')
							.attr('aria-expanded', 'true');
						this.$container.addClass('autocompleteVisible');
						if (this.inCallout) {
							this.$element.addClass('autocompleteInputInCallout');
							this.$container.addClass('autocompleteInCallout');
							if (this.$element.parent('.labelIconOnly').length) {
								this.$autocomplete.insertAfter(this.$element.parent());
							} else {
								this.$autocomplete.insertAfter(this.$element);
							}
						} else {
							$(window).on('resize.autocomplete.' + id, shared.debounce(function () {
								self._positionAutocomplete();
								return true;
							}, 100));
							if (this.inModal) {
								this.$container.addClass('autocompleteInModal');
								this.$autocomplete.appendTo('#modal');
							}
						}
						$('html')
							.on('touchstart.autocomplete.' + id, function (e) {
								return self._handleHtmlTouchstart(e);
							})
							.on('touchend.autocomplete.' + id + ' click.autocomplete.' + id, function (e) {
								return self._handleHtmlTouchendOrClick(e);
							});
						$('body').on('focusin.autocomplete.' + id + ' mousedown.autocomplete.' + id, function (e) {
							return self._handleFocusOrMouseDownOnOtherElement(e);
						});
						this.isOpen = true;
						this._bindMouseEvents();
						this.observer.observe(document.body, this.observerOptions);
						this.$element.trigger('opened.autocomplete');
					}
				},
				'_populate': function (results) {
					var self = this,
						elementId = self.$element.attr('id');
					if (shared.isValidCallback(this.config.onResponse)) {
						this.config.onResponse.apply(this.$element, [results]);
					}
					if (results.length) {
						results = results.slice(0, this.config.maxResults);
						results.forEach(function (item, i) {
							var $result = self._buildResult(item, i, elementId);
							self.$resultsList.append($result);
						});
						if (self.$resultsList.find('.autocompleteChecked').length) {
							self.$resultsList.addClass('autocompleteHasChecks');
						}
					} else {
						this.$resultsList
							.html('<li class="autocompleteResult autocompleteNoResults" role="alert" label="Search Results">' + shared.localize(autocomplete.staticProperties.langSets, 'noMatches') + '</li>')
							.on('click.autocomplete.noResults', function () {
								/* Prevent closing modal */
								return false;
							});
						this.$element.removeData('raw');
					}
					this.$element.trigger('populated.autocomplete');
				},
				'_positionAutocomplete': function () {
					var self = this;
					this._positionContainer();
					if (this.inModal) {
						/* need to mirror the modal positioning delay */
						setTimeout(function () {
							self._positionContainer();
						}, 300);
					}
				},
				'_positionContainer': function () {
					var offset = this.$element.offset(),
						top,
						modalPadding,
						$modal;
					this.$container.css('max-height', '');
					top = Number(offset.top + this.$element.outerHeight(false));
					if (this.inModal) {
						$modal = $('#modal');
						/* remove these conditionals and use touch behavior when modal no longer relies on isTouchDevice */
						if ($modal.css('position') === 'absolute') {
							/* touch behavior */
							modalPadding = parseInt($('#modalContents').css('padding'), 10);
							this.$container.css('max-height', $('#modal').outerHeight(true) - top - modalPadding);
						} else if ($modal.css('position') === 'fixed') {
							/* noTouch behavior */
							top -= $(document).scrollTop();
						}
					}
					this.$container.css({
						'top': top,
						'left': offset.left,
						'width': this.$element.outerWidth(false)
					});
				},
				'_retrieveResults': function () {
					var config = this.config,
						convertedData,
						enoughCharacters = false,
						prevTerm = this.term,
						results;
					this.term = this.$element.val();
					/*	Don't run if term hasn't changed and already open or
						if the user has already moved onto another element. */
					if ((this.term === prevTerm && this.isOpen) || !this.$element.is(':focus')) {
						return;
					}
					enoughCharacters = this.term.length >= config.minLength;
					if (!enoughCharacters) {
						if (config.alwaysOpenOnFocus && !this.isOpen) {
							this._open();
						} else if (!config.alwaysOpenOnFocus && this.isOpen) {
							this.close();
						} else {
							this.$resultsList.empty();
						}
					} else if (this.term !== this.$element.attr('placeholder')) { /* can remove the placeholder check once form.js is updated */
						if (shared.isValidCallback(config.onSearch)) {
							config.onSearch.apply(this.$element, [this.term]);
						}
						if (Array.isArray(this.cachedData[this.term.toLowerCase()])) {
							results = this.cachedData[this.term.toLowerCase()];
						} else if ($.isFunction(config.source)) {
							convertedData = shared.isValidCallback(config.jsonConversion) ? config.jsonConversion.apply(this.$element, [config.source.apply(this.$element, [this.term])]) : config.source.apply(this.$element, [this.term]);
							results = convertedData;
						} else if (typeof config.source === 'object') {
							convertedData = (shared.isValidCallback(config.jsonConversion)) ? config.jsonConversion.apply(this.$element, [config.source, config]) : config.source;
							results = this._cacheResults(convertedData);
						} else if (typeof config.source === 'string') {
							if (this.results && this.results.length) {
								results = this._cacheResults(this.results);
							} else {
								this._ajaxRequest();
							}
						}
						if (results) {
							if (!results.length && config.disableNoResultsMessage) {
								this.close();
							} else {
								this._open();
								this._populate(results);
							}
						}
					}
				},
				'run': shared.debounce(function () {
					this._retrieveResults();
				}, 200),
				'_selectItem': function ($item) {
					var config = this.config,
						raw = $item.data('raw');
					if ($item && this.$focus && $item[0] === this.$focus[0]) {
						this.$element
							.data('raw', raw)
							.val($item.data('value'));
						if (shared.isValidCallback(config.onResultSelect)) {
							shared.warn('DEPRECATION NOTICE: Please replace "onResultSelect" with "onItemSelect"');
							config.onResultSelect.apply(this.$element, [$item]);
						}
						if (shared.isValidCallback(config.onItemSelect)) {
							config.onItemSelect.apply(this.$element, [raw]);
						}
					} else {
						this.$element.removeData('raw');
					}
					this.$element.focus();
					this.close();
				}
			},
			'staticProperties': {
				'defaults': {
					'ajaxOverride': {}, /* This will be merged into the object that gets passed into the $.ajax method */
					'alwaysOpenOnFocus': false, /* Boolean: Opens the autocomplete container whether or not the minLength is met */
					'customDisplay': false, /* function (data) { return { "value": value, "display": value, "disabled": boolean, "checked": boolean }; },  MUST RETURN OBJECT; Custom function for displaying the returned data. 'disabled' and 'checked' properties are not required. */
					'dataType': 'json', /* defaults to json; 'xml' if xml data */
					'disableNoResultsMessage': false, /* autocomplete will be closed rather than show a no results message */
					'highlight': true, /* default: true, other options: { 'open': 'yourOpenChars', 'close': 'yourCloseChars' }, or false */
					'jsonConversion': false, /* Custom function for converting data to properly formatted json: function (data, options) { return [{key:value, key2:value},{key:value, key2:value}]; } */
					'key': '', /* REQUIRED; Key for key:value pair you are searching for */
					'matchBeginning': false, /* Allows you to return only matches based on the first characters */
					'maxResults': 20, /* Max results shown */
					'minLength': 3, /* Number of characters to use for search; minimum of 1 */
					'onChange': false, /* Callback function run when the autocomplete value changes. function () { } (this === $input) */
					'onClose': false, /* Callback function run when autocomplete is closed: function ($resultContainer, $before, $after) { } (this === $input) */
					'onCreate': false, /* Callback function run when autocomplete is created. function () { } (this === $input) */
					'onError': false, /* Callback function run if an ajax request fails. function (jqXHR, textStatus, errorThrown) { } (this === $input) */
					'onFocus': false, /* Callback function run when a result item is focused. function ($item) { } (this === $input) */
					'onItemSelect': false, /* Callback function run when an item is selected from dropdown: function (itemData) { } (this === $input) */
					'onOpen': false, /* Callback function run when autocomplete is opened: function ($resultContainer, $before, $after) { } (this === $input) */
					'onResponse': false, /* Callback function run when autocomplete receives a response. function (results) { } (this === $input) */
					'onSearch': false, /* Callback function run when autocomplete is ready to perform a search. function (term) { } (this === $input) */
					'queryParameter': false, /* REQUIRED FOR SERVICE CALL; false, if none needed; otherwise string */
					'source': '' /* REQUIRED; The url of the data or an array of objects representing searchable data. */
				},
				'langSets': {
					'de': {
						'noMatches': 'Keine &#220;bereinstimmungen gefunden'
					},
					'en': {
						'noMatches': 'No matches found'
					},
					'es': {
						'noMatches': 'No se encontraron concordancias'
					},
					'fr': {
						'noMatches': 'Aucune correspondance trouv&#233;e'
					},
					'it': {
						'noMatches': 'Nessuna corrispondenza trovata'
					},
					'sv': {
						'noMatches': 'Inga matchningar hittades'
					}
				}
			}
		},
		version = 2,
		doubleIncluded = !!$.autocomplete;
	if (doubleIncluded) {
		if ($.autocomplete.version === version) {
			shared.warn('ERROR: You are including autocomplete.js multiple times');
			return;
		} else {
			shared.warn('ERROR: You are including multiple versions of autocomplete.js');
			if ($.autocomplete.version > version) {
				return;
			}
		}
	}
	$.fn.autocomplete = function (options) {
		var isMethodCall = typeof options === 'string', /* If options is a string, we assume it refers to a method. */
			args = arguments,
			returnValue = this;
		this.each(function () {
			var $this = $(this),
				instance = $this.data('autocompleteInstance'),
				methodValue;
			if (isMethodCall) {
				if (!instance) {
					shared.warn('Cannot call methods on autocomplete prior to initialization; attempted to call method "' + options + '".');
					return false;
				}
				if (!$.isFunction(instance[options]) || options.indexOf('_') === 0) {
					shared.warn('No such method "' + options + '" for autocomplete.');
					return false;
				}
				methodValue = instance[options].apply(instance, Array.prototype.slice.call(args, 1));
				if (methodValue !== instance && methodValue !== undefined) {
					returnValue = methodValue && methodValue.jquery ? returnValue.pushStack(methodValue.get()) : methodValue;
					return false;
				}
			} else {
				autocomplete.create($this, options);
			}
		});
		return returnValue;
	};
	$.autocomplete = {
		'close': function () {
			var $autocompleteInput = $('.autocompleteAttached');
			if ($autocompleteInput.length) {
				$autocompleteInput.autocomplete('close');
			}
		},
		'getTest': function () {
			return $.extend({}, autocomplete);
		},
		'version': version
	};
}(jQuery));